import axios from 'axios'
import {Toast} from 'vant'
import store from '@/store'
import {loadToken} from '@/utils/cache'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      if (!config.params) {
        config.params = {}
      }
      config.params['token'] = loadToken()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    overlay: false,
    duration: 0,
    loadingType: 'spinner'
  })
  return config
}, function (error) {
  Toast.clear()
  return Promise.reject(error)
})
export function isJSON (str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
}
service.interceptors.response.use(function (response) {
  Toast.clear()
  return response
}, function (error) {
  var str = error.response.data.message
  var json = null
  var duration = 3000
  var message = 'Server Error'
  if (isJSON(str)) {
    json = JSON.parse(error.response.data.message)
    duration = json.duration
    message = json.message
  } else {
    message = error.response.data.message ? error.response.data.message : null
  }
  Toast({
    duration: duration,
    message: message
  })
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    return response
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js